exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-text.dark[data-v-0b859dbc]{border-top-color:#343a40;border-right-color:#343a40;border-bottom-color:#343a40}", ""]);

// exports
